<template>
  <div>
    <el-table
      :data="data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
    >
      <el-table-column
        label="Company"
        prop="company.name"
        sortable
      ></el-table-column>
      <el-table-column
        label="Library share"
        prop="library_share"
        sortable
      ></el-table-column>
      <el-table-column
        label="Number of tracks"
        prop="num_tracks"
        sortable
      ></el-table-column>
      <el-table-column label="Total" prop="total" sortable></el-table-column>
      <el-table-column
        label="Currency"
        prop="currency_iso"
        sortable
      ></el-table-column>
      <el-table-column
        label="Invoice ID"
        prop="invoice_id"
        sortable
      ></el-table-column>
      <el-table-column
        label="Library ID"
        prop="library_id"
        sortable
      ></el-table-column>
      <el-table-column label="Created at" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="data.current_page"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="data.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('reportLibraryShare', [
      'data',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('reportLibraryShare', ['read']),
    ...mapMutations('reportLibraryShare', [
      'setPage',
      'setPageSize',
      'setOrdering'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    }
  },

  created() {
    this.read()
  }
}
</script>
